import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { Goals } from './Community/Letter/Goals';
import { LoginCommunity } from './Community/Login/Login';
import { RegisterCommunity } from './Community/Register/RegisterCommunity';
import { NavMenu } from './NavMenu';
import { NavMenuLateral } from './NavMenuLateral';

export class Layout extends Component {
    static displayName = Layout.name;

    constructor(props) {
        super(props);
        this.state = {
            isFull: window.location.pathname == '/' || window.location.pathname == '/iniciar-sesion'
        }
    }

    componentDidUpdate() {
        alert()
    }

    static renderBanner() {
        /*if (window.location.href.substring(window.location.href.lastIndexOf('/'), window.location.href.length).length < 2) {
            return <div className="wrapp-banner">

                <div className="logo-banner"><img src={require('../images/logo.png')} /></div>


                <ul className="redes">
                    <li>
                        <a href="http://www.facebook.com/lifemedellin" className="facebook"><img src={require('../images/facebook.png')} /></a>
                    </li>
                    <li>
                        <a href="https://instagram.com/lifemedellin/" className="instagram"><img src={require('../images/instagram.png')} /></a>
                    </li>
                </ul>
                <div className="back"></div>


                <div className="rotator">
                    <img src={require('../images/banner.jpg')} />

                    <img src={require('../images/banner3.jpg')} hidden />

                    <img src={require('../images/banner2.jpg')} hidden />
                </div>



                <ul className="location">
                    <li>
                        Medell&iacute;n
        </li>
                    <li>
                        Rionegro
        </li>
                    <li>
                        Bogot&aacute;
        </li>
                </ul>
            </div>
        }*/
    }

    render() {

        let banner = Layout.renderBanner();

        if (window.location.href.toLocaleLowerCase().indexOf('comunidad/registro') > -1) {
            return (
                <RegisterCommunity />
            );
        }
        else if (window.location.href.toLocaleLowerCase().indexOf('comunidad') > -1) {
            if (!window.localStorage.getItem('token')) {
                return (
                    <LoginCommunity />
                );
            } else {
                return (
                    <div className="row community-container mr-0 ml-0">
                        <div className="col-sm-4 col-xs-4 col-lg-2">
                            <NavMenuLateral className="wrapp-menu" />
                        </div>
                        <div className="col-sm-8 col-xs-8 col-lg-7">
                            <Container>
                                {this.props.children}
                            </Container>
                        </div>
                        <div className="col-sm-0 col-xs-0 col-lg-3 content-right">
                            <Goals />
                        </div>
                        <div className="footer mt-5">
                        </div>
                    </div>
                );
            }
        } else {
            return (
                <div>
                    <NavMenu />
                    {/*banner*/}
                    {
                        this.state.isFull ? this.props.children :
                            <Container>
                                {this.props.children}
                            </Container>
                    }
                    <div className="footer">
                        <div className="row text-center">
                            <a href="http://www.facebook.com/lifemedellin" className="facebook"><img src={require('../images/facebook.png')} /></a>
                            <a href="https://instagram.com/lifemedellin/" className="instagram"><img src={require('../images/instagram.png')} /></a>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <a href="/terminos-y-condiciones" target="_blank">Términos y condiciones</a>
                            </div>
                            <div className="col-md-4">
                                <p>Desde el 2014 - Life Centro de Entrenamiento en Liderazgo CEL</p>
                            </div>
                            <div className="col-md-4">
                                <a href="/politica-de-datos" target="_blank">Políticas de privacidad</a>
                            </div>
                        </div>
                    </div>

                    <a href="https://api.whatsapp.com/send?phone=573216435539&text=Quiero recibir información del taller" target="_blank">
                        <div className="whatsapp footer"></div>
                    </a>

                </div>
            );
        }
    }
}